import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TiLocationOutline } from 'react-icons/ti';

import { ButtonText, Text, BoldText, LinkText } from '../../common/Text';
import { PrimaryButton } from '../../common/Buttons';
import StyledTappable from '../../common/StyledTappable';
import { fontSize } from '../../../utils';

const OuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0.25rem 0;
`;

const BubbleContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0.625rem 0.75rem;
  background: rgba(228, 220, 248, 0.2);
`;

const DoctorName = styled(Text)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  opacity: 0.5;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const MessageText = styled(Text)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin: 0.5rem 0;
`;

const LocationIcon = styled(TiLocationOutline)`
  margin-right: 0.75rem;
  color: white;
`;

const LocationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-self: stretch;
  align-items: center;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '0')};
`;

const SecondaryText = styled(BoldText)`
  color: #b3b3b3;
  font-size: ${fontSize(0.875)};
  margin-right: 0.5rem;
`;

const StyledButtonText = styled(ButtonText)`
  font-size: ${fontSize(0.875)};
`;

const StyledLinkText = styled(LinkText)`
  font-size: ${fontSize(0.875)};
`;

const DoctorLocationRequestMessage = ({
  className,
  topLabel,
  onDetectLocation,
  onSearchLocation,
}) => (
  <OuterContainer className={className}>
    <BubbleContainer>
      <DoctorName>{topLabel}</DoctorName>
      <MessageContainer>
        <MessageText>
          To see best suggestions, please Turn on Location
        </MessageText>
      </MessageContainer>
      <PrimaryButton onTap={onDetectLocation}>
        <LocationContainer>
          <LocationIcon />
          <StyledButtonText>TURN ON LOCATION</StyledButtonText>
        </LocationContainer>
      </PrimaryButton>
      <LocationContainer marginTop="1rem">
        <SecondaryText>or</SecondaryText>
        <StyledTappable onTap={onSearchLocation}>
          <StyledLinkText>SELECT A LOCATION</StyledLinkText>
        </StyledTappable>
      </LocationContainer>
    </BubbleContainer>
  </OuterContainer>
);

DoctorLocationRequestMessage.propTypes = {
  topLabel: PropTypes.string,
  onDetectLocation: PropTypes.func,
  onSearchLocation: PropTypes.func,
};

export default DoctorLocationRequestMessage;
